<template>
    <b-container>
        <div class="spacer"></div>
        <div v-for="(row, index) in visibleRows()" :key="index">
            <b-row>
                <b-col lg="6" v-bind:order-lg="(index%2 == 0) ? 1 : 2" class="textcol"><div class="wrapper"><div class="text"><span v-html="row.text"></span></div></div></b-col>
                <b-col lg="6" class="imagecol" v-bind:order-lg="(index%2 == 0) ? 2 : 1"><b-img :src="'bilder/werkzeugbau/'+row.image" :class="'image ' + (row.image.includes('.png') ? '' : 'img2')"></b-img></b-col>
            </b-row>
            <!--<div class="spacer"></div>-->
        </div>
        <div class="spacer"></div>
    </b-container>
</template>

<script>
import axios from 'axios'
export default {
    data() {
        return {
            data: {},
            test: 'test'
        }
    },
    mounted() {
        axios.get('/konfiguration/werkzeugbau.json').then((response) => {
            this.data = response.data
        }).catch((err)=>{this.test=err});
    },
    methods: {
      visibleRows: function () {
        return this.data.rows.filter(function(row) {return row.visible == true;});
      }
    }
}
</script>

<style scoped>
@media only screen and (max-width: 992px) { 
    [class*='col-'] {
        /*padding: 0px!important;*/
        padding-left: 0px!important;
        padding-right: 0px!important;
    }

    img {
        padding: 0px!important;
    }

    .spacer {
        height: 0!important;
    }
}

@media only screen and (max-width: 576px) { 
    [class*='col-'] {
        padding: 0px!important;
    }
}

.text {
    display: table-cell;
    vertical-align: middle;
    background-color: #efefef;
    height: 100%;
    padding: 30px;
    font-size: 25px;
}

.wrapper {
    display: table;
    height: 100%;
    width: 100%;
}

img {
    object-fit: contain;
    height: 100%;
    width: 100%;
    padding: 10px;
}

.img2 {
    object-fit: cover;
}

.imagecol {
    padding-right: 0;
    padding-left: 0;
}

.image {
    background-color: #363636;
}
/*
.col-md-6 {
    height: 100%;
    padding: 10px;
}

.row {
    height: 500px;
    min-height: 500px;
}
*/
.row {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  min-height: 500px;
  margin-right: 0px;
  margin-left: 0px;
}
.row > [class*='col-'] {
  display: flex;
  flex-direction: column;
  padding: 10px;
  min-height: 500px;
}

.spacer {
    height: 50px;
    width: 100%;
    /*background-color: white;*/
}
</style>